import PropTypes from 'prop-types';
import { RiArrowGoBackLine } from 'react-icons/ri';
import ConfirmationModal from '@/components/confirmation-modal/confirmation-modal';
import Styled from './revert-icon-button-style';

/**
 * Reusable revert icon button component with tooltip and confirmation modal
 * @param {object} props - Component props
 * @param {Function} props.onClick - Click handler function
 * @param {string} props.tooltipMessage - Message to display in tooltip and modal title
 * @param {number} props.size - Size of the icon (default: 14)
 * @param {string} props.confirmButtonText - Text for the confirm button (default: 'Yes, revert')
 * @param {string} props.confirmMessage - Message to display in the modal body
 * @param {string} props.$margin - Margin of the button
 * @returns {JSX.Element} The rendered revert icon button component
 */
const RevertIconButton = ({
  onClick,
  tooltipMessage,
  size = 14,
  confirmButtonText = 'Yes, revert',
  confirmMessage = 'Are you sure you want to revert this change?',
  $margin,
}) => {
  const handleClick = () => {
    ConfirmationModal({
      title: tooltipMessage,
      text: confirmMessage,
      confirmButtonText,
      showCancelButton: true,
      onConfirm: onClick,
    });
  };

  return (
    <Styled.StyledRevertButton $margin={$margin}>
      <RiArrowGoBackLine size={size} onClick={handleClick} />
    </Styled.StyledRevertButton>
  );
};

RevertIconButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  tooltipMessage: PropTypes.string.isRequired,
  size: PropTypes.number,
  confirmButtonText: PropTypes.string,
  confirmMessage: PropTypes.string,
  $margin: PropTypes.string,
};

RevertIconButton.defaultProps = {
  size: 14,
  confirmButtonText: 'Yes, revert',
  confirmMessage:
    'Are you sure you want to revert this change? This action cannot be undone.',
  $margin: '0',
};

export default RevertIconButton;
